import { createCompareFn } from 'utils/sort';

export const MOST_RECENT_ACTIVITY = 'mostRecentActivity';
export const MOST_RECENT_COMPLETED = 'mostRecentCompleted';
export const ALPHABETICAL = 'aToZ';

function getMostRecentActivityDate(content) {
  return Math.max(
    content.progress.startTimestamp,
    content.progress.completedTimestamp,
  );
}

function getMostRecentJourneyActivityDate(content) {
  const completedDate = content.progress.completedDate
    ? Date.parse(content.progress.completedDate)
    : 0;

  return Math.max(Date.parse(content.progress.startedAt), completedDate);
}

export const historySortOptions = {
  [MOST_RECENT_ACTIVITY]: {
    label: () => t('content.sort.most_recent'),
    sort: createCompareFn(getMostRecentActivityDate, 'desc'),
  },
  [ALPHABETICAL]: {
    label: () => t('content.sort.alphabet_range'),
    sort: createCompareFn('title'),
  },
};

export const historyJourneySortOptions = {
  [MOST_RECENT_ACTIVITY]: {
    label: () => t('content.sort.most_recent'),
    sort: createCompareFn(getMostRecentJourneyActivityDate, 'desc'),
  },
  [ALPHABETICAL]: {
    label: () => t('content.sort.alphabet_range'),
    sort: createCompareFn('title'),
  },
};
